import { actionTypes } from "../contants/actionTypes";
import { callApi } from "../../services/api.service";
import { ensureArray } from "../../utils/validateResponseApi";

export const sessionStateLoadStart = () => ({
    type: actionTypes.sessionStateLoadStart,
});

export const sessionStateLoadFinish = () => ({
    type: actionTypes.sessionStateLoadFinish,
});

export const companyConfigLoadCompanies = (companies) => ({
    type: actionTypes.companyConfigLoadCompanies,
    payload: companies,
});

export const companyConfigSetSelected = (companyData) => {
    return {
        type: actionTypes.companyConfigSetSelected,
        payload: companyData,
    };
};

export const companyConfigError = (error) => ({
    type: actionTypes.companyConfigError,
    payload: error,
});

export const fetchUserCompaniesAction = (accessToken) => {
    return (dispatch) => {
        dispatch(sessionStateLoadStart());
        callApi("company_select", "SELECT_USER_COMPANIES", {}, accessToken)
            .then((response) => {
                const companies = ensureArray(response.data);
                dispatch(companyConfigLoadCompanies(companies));
                if (companies.length === 1) {
                    dispatch(companyConfigSetSelected(companies[0]));
                }
            })
            .catch((error) => {
                dispatch(companyConfigError(error.message));
            })
            .finally(() => {
                dispatch(sessionStateLoadFinish());
            });
    };
};

export const selectCompany = (companyData) => {
    return (dispatch) => {
        dispatch(companyConfigSetSelected(companyData));
    };
};

export const initCompanyConfig = (accessToken) => {
    return (dispatch) => {
        dispatch(fetchUserCompaniesAction(accessToken));
    };
};

// Company View (temporal/impersonate)
export const startViewAsCompany = (companyData) => ({
    type: actionTypes.companyConfigStartViewAs,
    payload: companyData,
});

export const endViewAsCompany = () => ({
    type: actionTypes.companyConfigEndViewAs,
});

export const setConfigurationDataCompany = (data) => ({
    type: actionTypes.companyConfigSetConfigurationData,
    payload: data,
});

//#region Actions or changes Pending
export const setSessionStateChangesPending = (dataBool) => ({
    type: actionTypes.sessionStateChangesPending,
    payload: dataBool,
});

export const setSessionStateActionsPending = (data) => ({
    type: actionTypes.sessionStateActionPending,
    payload: data,
});

export const setSessionStateActionRequired = (dataBool) => ({
    type: actionTypes.sessionStateActionRequired,
    payload: dataBool,
});
//#endregion